import { render, staticRenderFns } from "./homeworkIndex1.vue?vue&type=template&id=05e8eedf&scoped=true"
import script from "./homeworkIndex1.vue?vue&type=script&lang=js"
export * from "./homeworkIndex1.vue?vue&type=script&lang=js"
import style0 from "./homeworkIndex1.vue?vue&type=style&index=0&id=05e8eedf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e8eedf",
  null
  
)

export default component.exports